exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#new-sub-alert-user[data-v-05557fb8] {\n    padding: 5px 8px;\n    border: 1px dashed #ccc;\n}\n#new-sub-alert-user[data-v-05557fb8]:hover {\n    cursor: pointer;\n}\n", ""]);

// exports
